import React from "react";
import type { AriaRadioGroupProps } from "react-aria";
import { useRadioGroup } from "react-aria";
import { useRadioGroupState } from "react-stately";
import { twMerge } from "tailwind-merge";
import { tv } from "tailwind-variants";

import { RadioGroupContext } from "./context/radio-group-context";
import type { SlotClassNames } from "./types";

const radioGroup = tv({
  slots: {
    base: "flex flex-col gap-2",
    label: "text-text-primary mb-1",
  },
});

export type RadioGroupProps = Omit<AriaRadioGroupProps, "children"> & {
  readonly label?: string;
  readonly className?: string;
  readonly children?: React.ReactNode;
  readonly classNames?: SlotClassNames<ReturnType<typeof radioGroup>>;
  readonly value?: string;
};

export default function RadioGroup({
  className,
  classNames,
  children,
  ...props
}: RadioGroupProps) {
  const state = useRadioGroupState(props);

  const { radioGroupProps, labelProps } = useRadioGroup(props, state);
  const styles = radioGroup();

  return (
    <div
      {...radioGroupProps}
      className={styles.base({
        className: twMerge(className, classNames?.base),
      })}
    >
      {props.label && (
        <span
          {...labelProps}
          className={styles.label({ className: classNames?.label })}
        >
          {props.label}
        </span>
      )}
      <RadioGroupContext.Provider value={state}>
        {children}
      </RadioGroupContext.Provider>
    </div>
  );
}
